import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MfeCoreModule, ShellService } from '@mynexus/mfe-core';
import { API_BASE_URL, HH_API_BASE_URL } from './service';
import { ProductNames } from '@mynexus/mynexus-ui-lib';

@NgModule({
  declarations: [],
  exports: [CommonModule, MfeCoreModule],
  imports: [CommonModule, MfeCoreModule],
  providers: [
    ShellService,
    {
      provide: API_BASE_URL,
      useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.SDoH),
      deps: [ShellService]
    },
    {
      provide: HH_API_BASE_URL,
      useFactory: (shellService: ShellService) => shellService.getBaseUrlFor(ProductNames.HomeHealth),
      deps: [ShellService]
    },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class CoreModule { }
